import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PostulanteApiRestService } from '../../../services/postulanteApiRest.service';
import { Postulante } from '../../../models/Postulante';
import { Favoritox, Postulantex } from 'src/app/models/Postulantex';
import { FavoritoApiRestService } from '../../../services/favoritoApiRest.service';

interface Persona {
  nombre: string;
  favoritos: Favorito[]
}
interface Favorito{
  id:number;
  nombre: string;
}

@Component({
  selector: 'app-FormPostulanteNested',
  templateUrl: './FormPostulanteNested.component.html',
  styleUrls: ['./FormPostulanteNested.component.css']
})
export class FormPostulanteNestedComponent implements OnInit {

  nuevoJuego: string = '';
  
  persona: Persona = {
    nombre: 'Percy Rojas',
    favoritos: [
    { id: 1, nombre: 'PS4' },
    { id: 2, nombre: 'Cars' },
    { id: 3, nombre: 'GIS' },
  ]
  }

  postulante: Postulantex;

  constructor(
    private postulanteApiRestService: PostulanteApiRestService,
    private favoritoApiRestService :FavoritoApiRestService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    //cargarmos la Ficha de Postulante si existen Dato
    this.cargarFichaPostulante();
  }
  //----------------------------------------------------
  cargarFichaPostulante(){
    this.activatedRoute.params.subscribe( params => {
      //creamos una variable para almacenar la "id" enviada por paramentro
      let id = params['id'];
      if(id){
        this.postulanteApiRestService.getPostulantePorId(id).subscribe( postulante => {
          this.postulante = postulante;
          console.log('Postulantex: ',postulante)
        })
      }
    })

  }
  //----------------------------------------------------

  guardar(){
    console.log('Formulario ... posteado.: ',this.postulante);
  }

  eliminarFavorito(indice: number){
    this.postulante.favoritos.splice(indice,1);
  }

  agregarFavorito(){

    const nuevoFavorito: Favoritox = {
      id: this.postulante.favoritos.length+1,
      nombre: this.nuevoJuego,
      postulante_id: this.postulante.id
    }

    this.postulante.favoritos.push({ ...nuevoFavorito });
    this.nuevoJuego = '';
  }

  //----------------------------------------------
  crearPostulante(){
    this.postulanteApiRestService.crearPostulante(this.postulante).subscribe( postulante => {
      this.router.navigate(['/postulantes']);
      console.log('Postulantex CREADO: ',postulante)
    })

    

  }

  actualizarPostulante(){
    this.postulanteApiRestService.actualizarPostulante(this.postulante).subscribe( postulante => {
      //this.router.navigate(['/postulantes']);
      console.log('Postulantex ACTUALIZADO: ',postulante)
    })

    if (this.postulante.favoritos.length > 0) {
      for (var val of this.postulante.favoritos) {
        //console.log(val); 
        this.favoritoApiRestService.eliminarFavoritoPorPostulanteId(val.postulante_id).subscribe(favorito => {
          console.log('Favoritox ELIMINADO: ', favorito)
        })
      }
    }

    for (var val2 of this.postulante.favoritos){
      this.favoritoApiRestService.crearFavorito(val2).subscribe( favorito => {
        console.log('Favoritox AGREGADO: ', favorito)
      })
    }
    this.router.navigate(['/postulantes']);

  }

}
